import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CardRenewalRoutingModule } from './card-renewal-routing.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { CardRenewalComponent } from './card-renewal.component';
import { ComponentsModule } from 'src/app/shared/components/components.module';


@NgModule({
  declarations: [CardRenewalComponent],
  imports: [
    CommonModule,
    CardRenewalRoutingModule,
    ComponentsModule,
    MaterialModule
  ],
  exports: [RouterModule]
})
export class CardRenewalModule { }
